<div class="default-error-page">
      <div class="data-box ">
        <span class="mr-5"><i class="n4icon-settings-outline mr-3 rotate"></i></span>
        <span>{{'MESSAGES.ERROR_PAGE' | translate}}</span>
      </div>
</div>


